import React, { useEffect, useRef, useState, useCallback } from 'react';
import { pageAtom, topMessageAtom, displayNameAtom } from '../../State';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function MobileEditName({ setShowEditName }) {
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [displayNameState, setDisplayNameState] = useRecoilState(displayNameAtom);
  const [codeState, setCodeState] = useState('');
  const inputRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate(); //リダイレクト用

  const handleChange = (event) => {
    setCodeState(event.target.value);
  };

  const tapClose = (event) => {
    setCodeState('');
    setShowEditName(false);
  };

  const tapSend = async () => {
    if (codeState != '') {
      setDisplayNameState(codeState);
      setShowEditName(false);
    }
  };

  useEffect(() => {
    inputRef.current.focus();

    setCodeState(displayNameState);
  }, []);

  const handleKeyDown = (e) => {
    if (e.key !== 'Enter') return;
    tapSend();
  };

  //レンダー
  return (
    <>
      <div id="electronEmailWrap">
        <div id="electronEmailBack" onClick={tapClose}></div>
        <div id="electronEmailInside">
          <>
            <h1>{t('haircheck.Display Name')}</h1>

            <input
              id="electronEmailInput"
              name="email"
              type="text"
              placeholder={t('haircheck.Type Display Name')}
              onChange={(e) => handleChange(e)}
              value={codeState}
              ref={inputRef}
              onKeyDown={handleKeyDown}
            />
            <button disabled={codeState != '' ? false : true} onClick={tapSend}>
              {t('mypage.Save')}
            </button>

            <div id="electronJoinClose" onClick={tapClose}>
              {t('setting.Close')}
            </div>
          </>
        </div>
      </div>
    </>
  );
}
